import React from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';

import FailsafeImg from 'components/global/application/FailsafeImg';

import { imageUrlAppendStyle } from 'contexts/link_util';
import CartItem from 'types/shopify/CartItem';

import './CartItemRow.sass';

export interface OwnProps {
    item: CartItem;
}

export interface StateProps {
    price: number;
}

export interface DispatchProps {
    removeItem(item: CartItem): void;
    updateItem(item: CartItem): void;
}

type CombinedProps = OwnProps & DispatchProps;

const CartItemRow: React.StatelessComponent<CombinedProps> = (props: CombinedProps) => {
    const { item, removeItem, updateItem  } = props;

    /**
     * Products are either instruments or accessories
     */
    const renderProductUrl = (cartItem: CartItem) => {
        if (cartItem.type === 'Instrument') {
            return (
                <Link to={`/${cartItem.field_gruhn_category_id}`}>
                    {cartItem.title}
                </Link>
            );
        }
        return (
            <Link to={`/accessories/${cartItem.productId}`}>
                {cartItem.title}
            </Link>
        );
    };

    return (
        <div className="cart-item-row-container">
            <div className="product-image">
                <Link to={`/accessories/${item.productId}`}>
                    <FailsafeImg
                        className="main-image"
                        src={imageUrlAppendStyle(item.imageSrc, 'gallery_thumbnail')}
                        alt=""
                    />
                </Link>
            </div>
            <div className="product-title">
                {renderProductUrl(item)}
                <button className="remove-product-from-cart" onClick={() => removeItem(item)} >Remove</button>
            </div>
            {item.type === 'Instrument'
                ? ''
                : (
                    <div className="quantity">
                        <Select
                            className="quantity-select"
                            name="quantity-select"
                            value={item.quantity}
                            onChange={(selection: { value?: number, label: string }) => updateItem({ ...item, quantity: selection.value })}
                            searchable={false}
                            clearable={false}
                            autosize={false}
                            options={Array.apply(null, { length: 31 }).map(Number.call, Number).slice(1).map((n: number) => {
                                return { value: n, label: n };
                            })}
                        />
                    </div>
                )
            }
            <div className="price">${(item.price * item.quantity).toFixed(2)}</div>
        </div>
    );
};

export default CartItemRow;



// WEBPACK FOOTER //
// ./src/components/pages/accessories/cart/CartItemRow.tsx